import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// Helper: inject subTenantId into request body if exists
const injectSubTenantId = (data) => {
  if (decodedToken?.isMultitenancy) {
    const subTenantIds = decodedToken?.subTenantIds?.split(",");
    if (subTenantIds && subTenantIds.length > 0) {
      const jsonData = JSON.parse(data);
      jsonData.subTenantDTO = { id: subTenantIds[0] };
      return JSON.stringify(jsonData);
    }
  }
  return data;
};

// Common headers
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": decodedToken?.tenantApiKey,
  };

  if (
    decodedToken?.roles?.includes("TENANT_ADMIN") &&
    !decodedToken?.subTenantId &&
    !decodedToken?.subTenantIds
  ) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const RuntimeConfigsApi = {
  // Create RuntimeConfigs
  CreateRuntimeConfigs: (data) => {
    data = injectSubTenantId(data);
    return apiApp
      .post(`/runtime-configs`, data, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Update RuntimeConfigs
  PutRuntimeConfigs: (storageID, data) => {
    data = injectSubTenantId(data);
    return apiApp
      .put(`/runtime-configs/${storageID}`, data, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Single RuntimeConfig
  SingleRuntimeConfigs: (storageID) => {
    return apiApp
      .get(
        `/runtime-configs/${storageID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List RuntimeConfigs
  ListRuntimeConfigs: () => {
    return apiApp
      .get(
        `/runtime-configs?size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Delete RuntimeConfigs
  DeleteRuntimeConfigs: (storageID) => {
    return apiApp
      .delete(
        `/runtime-configs/${storageID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },
};

export default RuntimeConfigsApi;
